import { Component } from 'react';

import { OnChangeType } from 'types/functions';
import { twclsx } from 'utils/twclsx';

import Icon from './Icon';

interface StarBoxProps {
    name?: string | number;
    className?: string;
    value: boolean;
    onChange?: OnChangeType;
    disabled?: boolean;
}

interface StarBoxState {
    value: boolean;
}

class StarBox extends Component<StarBoxProps, StarBoxState> {
    render() {
        const { className, name, value, disabled, onChange } = this.props;

        return (
            <button
                type="button"
                onClick={
                    onChange
                        ? disabled
                            ? () => {
                                  //console.log('Is disabled');
                              }
                            : () => {
                                  onChange(name || '', !value);
                              }
                        : () => {
                              //console.log('No click action');
                          }
                }
                className="cursor-pointer w-4 h-4"
            >
                <Icon className={twclsx('w-4', 'h-4', className)}>
                    <path
                        fill={value ? '#FFC000' : '#fffff'}
                        d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"
                    />
                </Icon>
            </button>
        );
    }
}

export default StarBox;
